<div class="sms-campaign-landing-page">
  <div class="landing-page-live-preview">
    <div class="landing-state-message" *ngIf="loading">
      <div class="state-spinner"></div>
      <p>Loading campaign...</p>
    </div>

    <div class="landing-state-message landing-state-error" *ngIf="!loading && error">
      <p>This offer isn't available right now. Please check back later.</p>
    </div>

    <form class="landing-live-card" *ngIf="!loading && !error" (ngSubmit)="onSubmit()">
      <div class="landing-live-logo" [class.has-image]="!!landingPage.logo">
        <img *ngIf="landingPage.logo" [src]="landingPage.logo" alt="Landing page logo" />
        <span *ngIf="!landingPage.logo">Logo</span>
      </div>
      <h5 class="landing-live-title">{{ landingPage.title }}</h5>
      <p class="landing-live-body">{{ landingPage.subtitle }}</p>
      <label class="landing-live-input-label" for="sms-landing-input">
        {{ landingPage.inputLabel }}<span class="required">*</span>
      </label>
      <input
        #smsLandingInputEl
        id="sms-landing-input"
        class="landing-live-input"
        [class.has-error]="!!inputError"
        [type]="getInputTypeAttr()"
        name="contact"
        [(ngModel)]="inputValue"
        (ngModelChange)="onInputChange()"
      />
      <p class="landing-input-error" *ngIf="inputError">{{ inputError }}</p>
      <button
        type="submit"
        class="landing-live-button"
        [disabled]="!inputValue.trim() || submitting"
        [style.backgroundColor]="landingPage.buttonColor"
      >
        {{ submitting ? 'Submitting...' : landingPage.buttonText }}
      </button>
      <p class="landing-input-error" *ngIf="submitError">{{ submitError }}</p>
      <div class="landing-live-consent" *ngIf="landingPage.showConsentBlock">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M7 1.16675L11.6667 3.20841V6.41675C11.6667 9.18758 9.57083 11.6084 7 12.8334C4.42917 11.6084 2.33333 9.18758 2.33333 6.41675V3.20841L7 1.16675Z"
            stroke="#079271"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.25 7L6.41667 8.16667L8.75 5.83333"
            stroke="#079271"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>
          <ng-container *ngFor="let segment of getConsentSegments()">
            <ng-container *ngIf="segment.type === 'text'">{{ segment.value }}</ng-container>
            <a
              *ngIf="segment.type === 'link' && hasConsentUrl"
              class="landing-live-consent-link"
              [href]="landingPage.consentUrl"
              target="_blank"
              rel="noopener noreferrer"
              >{{ segment.value }}</a
            >
            <button
              *ngIf="segment.type === 'link' && !hasConsentUrl"
              type="button"
              class="landing-live-consent-link landing-live-consent-link-btn"
              (click)="openConsentTermsModal($event)"
            >
              {{ segment.value }}
            </button>
          </ng-container>
        </span>
      </div>
    </form>
  </div>

  <app-sms-campaign-consent-terms-modal
    [isOpen]="showConsentTermsModal"
    [shop]="shopInfo"
    [location]="locationInfo"
    (close)="closeConsentTermsModal()"
  >
  </app-sms-campaign-consent-terms-modal>
</div>
